const LEVEL_RANK = { HIGH: 3, MEDIUM: 2, LOW: 1 };

export const normalizeAlertLevel = (level) => {
  const value = String(level || "").trim().toUpperCase();
  return LEVEL_RANK[value] ? value : "LOW";
};

const rank = (level) => LEVEL_RANK[normalizeAlertLevel(level)];

export const highestAlertLevel = (alerts = []) => alerts.reduce(
  (highest, alert) => (rank(alert?.level) > rank(highest) ? normalizeAlertLevel(alert.level) : highest),
  "LOW",
);

export const sortAlertsByLevel = (alerts = []) => alerts
  .map((alert, index) => ({ alert, index }))
  .sort((a, b) => rank(b.alert?.level) - rank(a.alert?.level) || a.index - b.index)
  .map(({ alert }) => alert);

// Maps the backend partydetails alert messages to the personal-details field they concern.
// Returns null for alerts that only belong in the banner.
export const classifyPartyAlert = (message) => {
  const text = String(message || "").toLowerCase();
  if (!text) return null;
  const isMissing = /\b(missing|absent|ausente)\b/.test(text);
  if (/date of birth|\bdob\b/.test(text)) {
    if (/suspicious/.test(text)) return { field: "dob", kind: "suspicious" };
    return isMissing ? { field: "dob", kind: "missing" } : null;
  }
  if (/e-?mail/.test(text) && isMissing) return { field: "email", kind: "missing" };
  if (/phone/.test(text) && isMissing) return { field: "phone", kind: "missing" };
  return null;
};

// { email|phone|dob: { kind, level, message } }, keeping the highest-level alert per field.
export const partyFieldFlags = (alerts = []) => alerts.reduce((flags, alert) => {
  const match = classifyPartyAlert(alert?.message);
  if (!match) return flags;
  const current = flags[match.field];
  if (current && rank(current.level) >= rank(alert.level)) return flags;
  return {
    ...flags,
    [match.field]: { kind: match.kind, level: normalizeAlertLevel(alert.level), message: alert.message },
  };
}, {});
